// /** @jsxImportSource @emotion/react */
// import React, { useEffect, useState } from "react";
// import * as styles from "./style";
// import { Card, Typography, Spin, Alert, Tag, Carousel } from "antd";
// import { useParams } from "react-router-dom";

// const { Title, Paragraph } = Typography;

// type Product = {
//   _id: string;
//   name: string;
//   description: string;
//   price: number;
//   isInstock: boolean;
//   images?: string[];
//   category?: string;
//   gender?: string;
//   vintage?: boolean;
// };

// export const DetailPage: React.FC = () => {
//   const { id } = useParams<{ id: string }>();
//   const [product, setProduct] = useState<Product | null>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   useEffect(() => {
//     if (!id) return;

//     setLoading(true);
//     fetch(`https://vip-resale.com/api/products/${id}`)
//       .then((res) => {
//         if (!res.ok) throw new Error("Product not found");
//         return res.json();
//       })
//       .then((data) => {
//         setProduct(data);
//         setError(null);
//       })
//       .catch((err) => {
//         setError(err.message);
//         setProduct(null);
//       })
//       .finally(() => setLoading(false));
//   }, [id]);

//   if (loading) return <Spin tip="Loading..." style={{ margin: 40 }} />;

//   if (error)
//     return (
//       <Alert
//         type="error"
//         message="Error"
//         description={error}
//         style={{ maxWidth: 600, margin: "40px auto" }}
//       />
//     );

//   if (!product) return null;

//   return (
//     <div css={styles.container}>
//       <Card
//         hoverable
//         cover={
//           product.images && product.images.length > 0 ? (
//             <Carousel autoplay>
//               {product.images.map((img, index) => (
//                 <div key={index}>
//                   <img
//                     css={styles.image}
//                     alt={`${product.name} ${index + 1}`}
//                     src={`http://vip-resale.com${img}`}
//                   />
//                 </div>
//               ))}
//             </Carousel>
//           ) : (
//             <img
//               css={styles.image}
//               alt="No image"
//               src="https://via.placeholder.com/800x400?text=No+Image"
//             />
//           )
//         }
//       >
//         <Title level={2} css={styles.title}>
//           {product.name}
//         </Title>
//         <Paragraph css={styles.description}>{product.description}</Paragraph>
//         <Paragraph>
//           <b>Price:</b> ${product.price.toFixed(2)}
//         </Paragraph>
//         <Paragraph>
//           <b>In Stock:</b>{" "}
//           {product.isInstock ? (
//             <Tag color="green">Yes</Tag>
//           ) : (
//             <Tag color="red">No</Tag>
//           )}
//         </Paragraph>
//         {product.category && (
//           <Paragraph>
//             <b>Category:</b> <Tag color="blue">{product.category}</Tag>
//           </Paragraph>
//         )}
//         {product.gender && (
//           <Paragraph>
//             <b>Gender:</b> <Tag color="purple">{product.gender}</Tag>
//           </Paragraph>
//         )}
//         {product.vintage && (
//           <Paragraph>
//             <b>Vintage:</b> <Tag color="volcano">Yes</Tag>
//           </Paragraph>
//         )}
//       </Card>
//     </div>
//   );
// };
/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import { Spin, Alert, Carousel } from "antd";
import { useParams } from "react-router-dom";
import * as styles from "./style";

type Product = {
  _id: string;
  name: string;
  description: string;
  price: number;
  isInstock: boolean;
  isPreOrder?: boolean;
  images?: string[];
  category?: string;
  gender?: string;
  vintage?: boolean;
};

export const DetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    fetch(`https://vip-resale.com/api/products/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Product not found");
        return res.json();
      })
      .then((data) => {
        setProduct(data);
        setError(null);
      })
      .catch((err) => {
        setError(err.message);
        setProduct(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div css={styles.page}>
        <div css={styles.loadingBox}>
          <Spin tip="Loading..." />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div css={styles.page}>
        <Alert
          type="error"
          message="Error"
          description={error}
          css={styles.errorBox}
        />
      </div>
    );
  }

  if (!product) return null;

  const availabilityText = product.isPreOrder
    ? "Під замовлення"
    : product.isInstock
    ? "Так"
    : "Ні";

  const orderNote = product.isPreOrder
    ? "Цей товар доступний під замовлення. Ми уточнимо терміни, комплект та всі деталі перед підтвердженням покупки."
    : "Цей товар доступний для замовлення. Ми уточнимо наявність, комплект та всі деталі перед підтвердженням покупки.";

  const details = [
    { label: "Розмір", value: "25 × 16 см" },
    { label: "Матеріал", value: "Lambskin leather" },
    { label: "Колір", value: "Black" },
    { label: "Стан", value: "Very good vintage condition" },
    { label: "Комплект", value: "Box, dust bag, card, Entrupy certificate" },
    { label: "Період", value: "1989–1991" },
  ];

  return (
    <section css={styles.page}>
      <div css={styles.inner}>
        <div css={styles.topLayout}>
          <div css={styles.imageCol}>
            <div css={styles.carouselWrap}>
              {product.images && product.images.length > 0 ? (
                <Carousel dots autoplay>
                  {product.images.map((img, index) => (
                    <div key={index}>
                      <img
                        css={styles.image}
                        alt={`${product.name} ${index + 1}`}
                        src={`https://vip-resale.com${img}`}
                      />
                    </div>
                  ))}
                </Carousel>
              ) : (
                <img
                  css={styles.image}
                  alt="Product placeholder"
                  src="https://via.placeholder.com/900x1100?text=No+Image"
                />
              )}
            </div>
          </div>

          <div css={styles.infoCol}>
            <h1 css={styles.title}>{product.name}</h1>

            <div css={styles.titleLine} />

            <p css={styles.description}>{product.description}</p>

            <a href="#details" css={styles.moreDetailsLink}>
              Більше деталей
            </a>

            <div css={styles.reference}>Ref. {product._id.slice(-6)}</div>

            <div css={styles.price}>${product.price.toFixed(2)}</div>

            <div css={styles.metaRow}>
              <span css={styles.metaLabel}>В наявності:</span>
              <span css={styles.metaValue}>{availabilityText}</span>
            </div>

            <div css={styles.swatches}>
              <button css={styles.swatch} aria-label="Gold">
                <span css={[styles.swatchInner, styles.swatchGold]} />
              </button>

              <button css={styles.swatch} aria-label="Silver">
                <span css={[styles.swatchInner, styles.swatchSilver]} />
              </button>
            </div>

            <div css={styles.buttonColumn}>
              <button css={styles.primaryButton}>Замовити</button>
              <button css={styles.secondaryButton}>Написати нам</button>
            </div>

            <p css={styles.note}>{orderNote}</p>
          </div>
        </div>

        <section id="details" css={styles.detailsSection}>
          <h2 css={styles.detailsTitle}>Деталі товару</h2>

          <div css={styles.detailsGrid}>
            {details.map((item) => (
              <div key={item.label} css={styles.detailItem}>
                <h3 css={styles.detailLabel}>{item.label}</h3>
                <p css={styles.detailValue}>{item.value}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
};
